import React, { useEffect, useState } from 'react';
import { trackAndNavigate } from '../utils/pixel';
const comparisonRows = [{
  without: 'Horas buscando material en Pinterest',
  with: 'Todo listo para imprimir en un lugar'
}, {
  without: 'Actividades sin secuencia ni criterio',
  with: '144 actividades organizadas por etapa'
}, {
  without: 'Familias sin saber qué hacer en casa',
  with: 'Actividades para casa claras y listas'
}, {
  without: 'Sesiones sin material visual de apoyo',
  with: 'Posters y tarjetas listos para usar'
}, {
  without: 'Sin recursos para trabajar creatividad',
  with: 'Hojas de dibujo y colorear por etapa'
}];
const TIMER_KEY = 'megapack_et_countdown_end';
const DURATION_MS = 24 * 60 * 60 * 1000;
function getEndTime(): number {
  if (typeof window === 'undefined') return Date.now() + DURATION_MS;
  const stored = localStorage.getItem(TIMER_KEY);
  if (stored) {
    const end = parseInt(stored, 10);
    if (end > Date.now()) return end;
  }
  const end = Date.now() + DURATION_MS;
  localStorage.setItem(TIMER_KEY, String(end));
  return end;
}
function getTimeLeft(endTime: number) {
  const diff = Math.max(0, endTime - Date.now());
  return {
    hours: Math.floor(diff / (1000 * 60 * 60)),
    minutes: Math.floor(diff % (1000 * 60 * 60) / (1000 * 60)),
    seconds: Math.floor(diff % (1000 * 60) / 1000)
  };
}
export function DarkCTA() {
  const [endTime] = useState<number>(() => getEndTime());
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(endTime));
  useEffect(() => {
    const timer = setInterval(() => setTimeLeft(getTimeLeft(endTime)), 1000);
    return () => clearInterval(timer);
  }, [endTime]);
  const pad = (n: number) => String(n).padStart(2, '0');
  const offers = [{
    emoji: '📦',
    name: 'MEGAPACK BASE',
    desc: '6 tomos + 6 bonos · 0 a 36 meses completo',
    before: '$39.990 ARS',
    price: '$19.990 ARS',
    label: '→ QUIERO EL BASE',
    href: 'https://checkout.construyeprogreso.com/cart/48185772966058:1',
    eventName: 'Megapack Base',
    value: 19990,
    highlight: false
  }, {
    emoji: '📋',
    name: 'GESTIÓN COMPLETA',
    desc: 'Pack Base + 6 Planillas Clínicas',
    before: '$54.990 ARS',
    price: '$27.990 ARS',
    label: '→ QUIERO GESTIÓN COMPLETA',
    href: 'https://checkout.construyeprogreso.com/cart/48185777684650:1',
    eventName: 'Megapack Gestión Completa',
    value: 27990,
    highlight: false
  }, {
    emoji: '🏆',
    name: 'CONSULTORIO PRO ⭐',
    desc: 'Pack Gestión Completa + Gabinete Visual Completo',
    before: '$69.990 ARS',
    price: '$32.990 ARS',
    label: '→ QUIERO CONSULTORIO PRO',
    href: 'https://www.bibliotecaprofesional.com/cart/48369090134186:1',
    eventName: 'Megapack Consultorio Profesional',
    value: 32990,
    highlight: true
  }];
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-16 sm:py-20 text-gray-900 text-base leading-6" style={{
    background: 'linear-gradient(180deg, rgb(224,242,254) 0%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-99">
      <div className="mx-auto max-w-4xl text-center" data-id="element-100">
        {/* Brand */}
        <div className="mb-8 sm:text-3xl font-black tracking-[3px] text-cyan-500 text-[18px]" data-id="element-101">
          👶 MEGAPACK ESTIMULACION TEMPRANA™
        </div>

        {/* Headlines */}
        <h2 className="text-xl sm:text-3xl font-bold text-gray-900 m-0 mb-3" data-id="element-102">
          La próxima sesión podés volver a improvisar.
        </h2>
        <p className="text-xl sm:text-3xl font-black text-cyan-500 m-0 mb-10" data-id="element-103">
          O podés entrar el lunes con todo resuelto desde hoy.
        </p>

        {/* Comparison Table */}
        <div className="mx-auto max-w-2xl mb-12 overflow-hidden rounded-2xl border border-gray-200 text-left bg-white" data-id="element-104">
          <div className="text-center font-bold text-gray-900 border-b border-gray-200 px-4 py-3 bg-gray-50" data-id="element-105">
            ¿Cuánto cuesta NO tenerlo?
          </div>
          <div className="grid grid-cols-2 border-b border-gray-200 bg-gray-50" data-id="element-106">
            <div className="text-center font-bold text-gray-500 px-4 py-2 text-sm" data-id="element-107">
              SIN MEGAPACK
            </div>
            <div className="text-center font-bold text-cyan-500 border-l border-gray-200 px-4 py-2 text-sm" data-id="element-108">
              CON MEGAPACK
            </div>
          </div>
          {comparisonRows.map((row, i) => <div key={i} className={`grid grid-cols-2 ${i < comparisonRows.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-109">
              <div className="px-4 py-2.5 text-xs sm:text-sm text-gray-500" data-id="element-110">
                ✗ {row.without}
              </div>
              <div className="px-4 py-2.5 text-xs sm:text-sm font-bold text-gray-900 border-l border-gray-100" style={{
            backgroundColor: 'rgba(0, 180, 216, 0.05)'
          }} data-id="element-111">
                ✓ {row.with}
              </div>
            </div>)}
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-112">
          <p className="font-bold text-gray-900 m-0 mb-4" data-id="element-113">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <div className="flex items-center justify-center" data-id="element-114">
            {[{
            value: pad(timeLeft.hours),
            label: 'hs'
          }, {
            value: ':',
            label: null
          }, {
            value: pad(timeLeft.minutes),
            label: 'min'
          }, {
            value: ':',
            label: null
          }, {
            value: pad(timeLeft.seconds),
            label: 'seg'
          }].map((item, i) => item.label === null ? <span key={i} className="mb-4 text-5xl sm:text-7xl font-black" style={{
            color: 'rgb(255,68,68)'
          }} data-id="element-115">
                  :
                </span> : <div key={i} className="flex flex-col items-center" data-id="element-116">
                  <span className="text-5xl sm:text-7xl font-black tabular-nums" style={{
              color: 'rgb(255,68,68)'
            }} data-id="element-117">
                    {item.value}
                  </span>
                  <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-118">
                    {item.label}
                  </span>
                </div>)}
          </div>
        </div>

        <p className="text-sm text-gray-600 m-0 mb-10" data-id="element-119">
          Después sube{' '}
          <span className="font-bold text-red-500" data-id="element-120">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* Pricing Cards — compact */}
        <div className="mx-auto max-w-3xl mb-10 flex flex-col gap-3" data-id="element-121">
          {offers.map(offer => <div key={offer.name} className="flex flex-col sm:flex-row items-center justify-between gap-3 rounded-xl px-5 py-4" style={{
          border: offer.highlight ? '2px solid #06b6d4' : '1px solid #e5e7eb',
          backgroundColor: offer.highlight ? 'rgb(240,249,255)' : 'rgb(255,255,255)',
          boxShadow: offer.highlight ? 'rgba(0,180,216,0.12) 0px 0px 24px 0px' : 'none'
        }} data-id="element-122">
              {/* Left: info */}
              <div className="flex items-center gap-3 text-left" data-id="element-123">
                <span className="text-2xl" data-id="element-124">{offer.emoji}</span>
                <div data-id="element-125">
                  <p className="text-sm font-black m-0" style={{
                color: offer.highlight ? '#06b6d4' : '#111827'
              }} data-id="element-126">
                    {offer.name}
                  </p>
                  <p className="text-xs text-gray-500 m-0" data-id="element-127">{offer.desc}</p>
                </div>
              </div>

              {/* Right: price + button */}
              <div className="flex items-center gap-4 shrink-0" data-id="element-128">
                <div className="text-right" data-id="element-129">
                  <p className="text-xs text-gray-400 line-through m-0" data-id="element-130">
                    {offer.before}
                  </p>
                  <p className="text-base font-black text-cyan-500 m-0" data-id="element-131">
                    {offer.price}
                  </p>
                </div>
                <a href={offer.href} onClick={e => {
              e.preventDefault();
              trackAndNavigate('InitiateCheckout', {
                content_name: offer.eventName,
                content_category: 'Estimulación Temprana',
                value: offer.value,
                currency: 'ARS'
              }, offer.href);
            }} className="shrink-0 bg-cyan-500 text-white text-xs font-black rounded-lg px-4 py-3 no-underline hover:opacity-90 transition-opacity whitespace-nowrap" data-id="element-132">
                  {offer.label}
                </a>
              </div>
            </div>)}
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-600" data-id="element-133">
          <span data-id="element-134">🔒 Pago 100% seguro</span>
          <span data-id="element-135">⚡ Acceso en 5 minutos</span>
          <span data-id="element-136">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-137">💳 Mercado Pago | Tarjeta | Transferencia</span>
        </div>
      </div>
    </section>;
}